<template>
  <div>
    <v-dialog :modelValue="open" max-width="450" @click:outside="$emit('cancel')" @keydown.esc="$emit('cancel')">
      <v-card>
        <v-card-title class="headline">Cancelar ASN{{ asn != null ? " #" + asn.id : "" }}</v-card-title>

        <v-card-text>
          <p class="mt-3 mb-3 fs-16 text-center">
            ¿Estás seguro que querés cancelar este ASN? La acción no se puede deshacer.
          </p>

          <v-textarea v-model="motivo" label="Motivo (opcional)" rows="3" autocomplete="off"></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="$emit('cancel')"> No </v-btn>

          <v-btn color="green darken-1" text @click="$emit('accept', motivo)" :loading="loading"> Si </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    open: Boolean,
    asn: { type: Object, default: null },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    motivo: "",
  }),
  watch: {
    open(value) {
      if (value) this.motivo = "";
    },
  },
  methods: {},
};
</script>
